import React, { useEffect, useRef, useState } from 'react';
import './SetTablePersonPrint.scss';
import moment from 'moment';
import RadioButtonGroup from "../../../../Components/RadioButtonGroup/RadioButtonGroup";
import { Button } from '../../../../Components/StyledComponents';
import CheckBox from '../../../../Components/CheckBox/CheckBox';
import axios from 'axios';
import { convertCost } from '../../../../Utils/functions';
import Select from 'react-select'

const SetTablePersonPrint = (props) => {
    const normal = 0.34
    const double = normal * 2
    const normal_height = 0.5
    const double_height = normal_height * 2

    const [ posMenuList, setPosMenuList ] = React.useState([]);

    useEffect(() => {
        getPosMenuList();
        if(Object.keys(props.person_print).length > 0) {
            setFontSize(props.person_print)
        }
    }, [])

    const getPosMenuList = () => {
        axios.get('/api/table/order/pos/info/Menu')
        .then((data)=>{
            setPosMenuList(data.data.Menu.map(item => ({
                value: item.Code, 
                label:`${item.Code} | ${item.Name} | ${convertCost(item.Price)}원`, 
                item:{value: item.Code}
            })))
        })
    }

    const selectMenu = (event) => {
        //let tmpMenuSelectList = price;
        //tmpMenuSelectList[index] = {...event.item, Name: {...tmpMenuSelectList[index].Name, ko: event.item.Name}};
        //setPrice([...tmpMenuSelectList]);
        console.log(event)
    }

    const [font_size, setFontSize] = useState({
        menu: '',
        line: 'slim',
        table: {
            size: 'large',
            bold: false,
            width: double,
            height: double_height
        },
        person: {
            size: 'large',
            bold: false,
            width: double,
            height: double_height
        }
    });
    
    const calcRenderSize = (size) => {
        let default_obj = {
            size: size
        }

        switch(size) {
            case 'small':
                return {
                    ...default_obj,
                    width: normal,
                    height: normal_height
                }
            case 'normal':
                return {
                    ...default_obj,
                    width: double,
                    height: normal_height
                }
            case 'large':
                return {
                    ...default_obj,
                    width: double,
                    height: double_height
                }
        }
    }

    const render_newline = () => {
        switch(font_size.line) {
            case 'slim':
                return <div style={{height: 10}}/>
            case 'normal':
                return <div style={{height: 20}}/>
            case 'wide':
                return <div style={{height: 30}}/>
        }
    }

    return (
        <div className='set-delivery-area'>
            <div className='row' style={{justifyContent:'space-between'}}>
                <div style={{justifyContent: 'center', flex: 1}}>
                    <div style={{width: 298.583, padding: 2, borderWidth: 0.5, borderStyle: 'solid'}}>
                        <br />
                        <br />
                        <div style={{ textAlign: 'center' }}>
                            시럽프렌즈 인원수 
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <p>------------------------------------------</p>
                        </div>
                        <div style={{textAlign: 'center'}}>
                        <div>
                                <svg preserveAspectRatio="none" viewBox="0 0 100 19" width={font_size.table.width * 7 + 'cm'} height={font_size.table.height + 'cm'}>
                                    <foreignObject height="100%" width="100%">
                                        <div style={{fontWeight: font_size.table.bold ? 'bold' : 'normal'}}>
                                            테이블: 12
                                        </div>
                                    </foreignObject>
                                </svg>
                            </div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <p>------------------------------------------</p>
                        </div>
                        <div>
                            <div className='row' style={{ paddingLeft: 5, paddingRight: 5, justifyContent:'space-between'}}>
                                <svg preserveAspectRatio="none" viewBox="0 0 100 19" width={font_size.person.width * 7 + 'cm'} height={font_size.person.height + 'cm'}>
                                    <foreignObject height="100%" width="100%">
                                        <div style={{fontWeight: font_size.person.bold ? 'bold' : 'normal'}}>
                                            인원수
                                        </div>
                                    </foreignObject>
                                </svg>
                                <svg preserveAspectRatio="none" viewBox="0 0 100 19" width={font_size.person.width * 7 + 'cm'} height={font_size.person.height + 'cm'}>
                                    <foreignObject height="100%" width="100%">
                                        <div style={{textAlign: 'end', fontWeight: font_size.person.bold ? 'bold' : 'normal'}}>
                                            1
                                        </div>
                                    </foreignObject>
                                </svg>
                            </div>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <p>------------------------------------------</p>
                        </div>
                        <div style={{paddingLeft: 5, paddingRight: 5}}>
                            {moment().format('YY-MM-DD HH:mm:ss')}
                        </div>
                        <br/>
                    </div>
                </div>
                <div className='area' style={{flex: 1}}>
                    <div className='info-box'>
                        <p className='info-box-title' style={{color: '#000', borderBottomWidth: 0}}>출력 프린터 연동 메뉴</p>
                        <div className='header-divider' />
                        <Select options={posMenuList} placeholder={'출력 프린터에 출력되는 메뉴 선택'} value={posMenuList.filter(function(option) { return option.value === font_size.menu})} onChange={event => setFontSize({...font_size, menu: event.value})} />
                        <p className='info-box-title' style={{color: '#000', marginTop: 64, borderBottomWidth: 0}}>인원수 간격</p>
                        <div className='header-divider' />
                        <RadioButtonGroup
                            perRows={3}
                            value={font_size.line}
                            id='line'
                            onChange={(value) => { setFontSize({...font_size, line: value}) }}
                            options={[
                                { label: '좁게', value: 'slim' },
                                { label: '기본', value: 'normal' },
                                { label: '넓게', value: 'wide' }
                            ]}
                            containerStyle={{ justifyContent: 'center' }}
                        />
                        <div className='row' style={{justifyContent:'space-between', marginTop: 64}}>
                            <p className='info-box-title' style={{color: '#000', borderBottomWidth: 0}}>인원수명</p>
                            <CheckBox checked={font_size.person.bold} label={'굵게'} onChange={() => setFontSize({...font_size, person: {...font_size.person, bold: !font_size.person.bold}})}/>
                        </div>
                        <div className='header-divider' />
                        <RadioButtonGroup
                            perRows={3}
                            value={font_size.person.size}
                            id='person_title'
                            onChange={(value) => { setFontSize({...font_size, person: {...font_size.person, ...calcRenderSize(value)}}) }}
                            options={[
                                { label: '작게', value: 'small' },
                                { label: '기본', value: 'normal' },
                                { label: '크게', value: 'large' }
                            ]}
                            containerStyle={{ justifyContent: 'center' }}
                        />
                        <div className='row' style={{justifyContent:'space-between', marginTop: 64}}>
                            <p className='info-box-title' style={{color: '#000', borderBottomWidth: 0}}>테이블</p>
                            <CheckBox checked={font_size.table.bold} label={'굵게'} onChange={() => setFontSize({...font_size, table: {...font_size.table, bold: !font_size.table.bold}})}/>
                        </div>
                        <div className='header-divider' />
                        <RadioButtonGroup
                            perRows={3}
                            value={font_size.table.size}
                            id='otable_title'
                            onChange={(value) => { setFontSize({...font_size, table: {...font_size.table, ...calcRenderSize(value)}}) }}
                            options={[
                                { label: '작게', value: 'small' },
                                { label: '기본', value: 'normal' },
                                { label: '크게', value: 'large' }
                            ]}
                            containerStyle={{ justifyContent: 'center' }}
                        />
                    </div>
                </div>
            </div>
            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => props.patchPersonPrint(font_size)}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default SetTablePersonPrint;